import type { Filter } from '@repo/api-codegen';
import {
	DataQualityClassification,
	DataQualityClassificationBounds,
} from '../enums/dataQualityClassification';

export function getDataQualityClassificationCatalogFilter(
	classification: DataQualityClassification,
	field: string
): Filter | null {
	switch (classification) {
		case DataQualityClassification.GREAT: {
			return {
				operands: [],
				field,
				operator: 'gte',
				value: DataQualityClassificationBounds.GREAT,
			};
		}
		case DataQualityClassification.GOOD: {
			return {
				operator: 'and',
				operands: [
					{
						operands: [],
						field,
						operator: 'gte',
						value: DataQualityClassificationBounds.GOOD,
					},
					{
						operands: [],
						field,
						operator: 'lt',
						value: DataQualityClassificationBounds.GREAT,
					},
				],
			};
		}
		case DataQualityClassification.MODERATE: {
			return {
				operator: 'and',
				operands: [
					{
						operands: [],
						field,
						operator: 'gte',
						value: DataQualityClassificationBounds.MODERATE,
					},
					{
						operands: [],
						field,
						operator: 'lt',
						value: DataQualityClassificationBounds.GOOD,
					},
				],
			};
		}
		case DataQualityClassification.POOR: {
			return {
				operands: [],
				field,
				operator: 'lt',
				value: DataQualityClassificationBounds.MODERATE,
			};
		}
		default: {
			return null;
		}
	}
}
